<template>
  <hm-content>
    <el-tabs v-model="activeTab" type="card" @tab-click="handleClick">
      <el-tab-pane :label="v.name" :name="v.id" v-for="(v, i) in oaMenu" :key="i"></el-tab-pane>
    </el-tabs>
    <div class="table oa-menu mb20">
      <div class="table-header flex">
        <div class="flex-1 text-center">级别</div>
        <div class="flex-1 text-center">类型</div>
        <div class="flex-1 text-center">菜单名称</div>
        <div class="flex-1 text-center">菜单链接</div>
      </div>
      <div class="table-body">
        <template v-for="(item, index) in currentMenu">
          <div
            class="flex table-row item-center"
            :key="index"
            v-if="
              (currentMenu[0].value && index === 0) || !currentMenu[0].value
            "
          >
            <div class="flex-1">{{ item.levelName }}</div>
            <div class="flex-1">
              <el-select size="small" v-model="item.menuType">
                <el-option :label="v.key" :value="v.value" v-for="(v, i) in typeOptions" :key="i"></el-option>
              </el-select>
            </div>
            <div class="flex-1">
              <el-input size="small" v-model="item.name"></el-input>
            </div>
            <div class="flex-1">
              <el-input size="small" v-model="item.value"></el-input>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="btn-wrapper mb20 flex flex-center">
      <el-button size="small" type="primary" @click="save">确 定</el-button>
      <el-button size="small" @click="$router.back(-1)">返 回</el-button>
    </div>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      activeTab: "0",
      oaMenu: [
        {
          id: "0",
          name: "菜单1",
          menuTab: 0,
          list: [
            {
              level: 1,
              levelName: "一级菜单",
              menuType: "",
              name: "",
              value: "",
              orderNum: 0,
              menuTab: 0
            },
            {
              level: 2,
              levelName: "二级菜单1",
              menuType: "",
              name: "",
              value: "",
              orderNum: 1,
              menuTab: 0
            },
            {
              level: 2,
              levelName: "二级菜单2",
              menuType: "",
              name: "",
              value: "",
              orderNum: 2,
              menuTab: 0
            },
            {
              level: 2,
              levelName: "二级菜单3",
              menuType: "",
              name: "",
              value: "",
              orderNum: 3,
              menuTab: 0
            },
            {
              level: 2,
              levelName: "二级菜单4",
              menuType: "",
              name: "",
              value: "",
              orderNum: 4,
              menuTab: 0
            },
            {
              level: 2,
              levelName: "二级菜单5",
              menuType: "",
              name: "",
              value: "",
              orderNum: 5,
              menuTab: 0
            }
          ]
        },
        {
          id: "1",
          name: "菜单2",
          menuTab: 1,
          list: [
            {
              level: 1,
              levelName: "一级菜单",
              menuType: "",
              name: "",
              value: "",
              orderNum: 0,
              menuTab: 1
            },
            {
              level: 2,
              levelName: "二级菜单1",
              menuType: "",
              name: "",
              value: "",
              orderNum: 1,
              menuTab: 1
            },
            {
              level: 2,
              levelName: "二级菜单2",
              menuType: "",
              name: "",
              value: "",
              orderNum: 2,
              menuTab: 1
            },
            {
              level: 2,
              levelName: "二级菜单3",
              menuType: "",
              name: "",
              value: "",
              orderNum: 3,
              menuTab: 1
            },
            {
              level: 2,
              levelName: "二级菜单4",
              menuType: "",
              name: "",
              value: "",
              orderNum: 4,
              menuTab: 1
            },
            {
              level: 2,
              levelName: "二级菜单5",
              menuType: "",
              name: "",
              value: "",
              orderNum: 5,
              menuTab: 1
            }
          ]
        },
        {
          id: "2",
          name: "菜单3",
          menuTab: 2,
          list: [
            {
              level: 1,
              levelName: "一级菜单",
              menuType: "",
              name: "",
              value: "",
              orderNum: 0,
              menuTab: 2
            },
            {
              level: 2,
              levelName: "二级菜单1",
              menuType: "",
              name: "",
              value: "",
              orderNum: 1,
              menuTab: 2
            },
            {
              level: 2,
              levelName: "二级菜单2",
              menuType: "",
              name: "",
              value: "",
              orderNum: 2,
              menuTab: 2
            },
            {
              level: 2,
              levelName: "二级菜单3",
              menuType: "",
              name: "",
              value: "",
              orderNum: 3,
              menuTab: 2
            },
            {
              level: 2,
              levelName: "二级菜单4",
              menuType: "",
              name: "",
              value: "",
              orderNum: 4,
              menuTab: 2
            },
            {
              level: 2,
              levelName: "二级菜单5",
              menuType: "",
              name: "",
              value: "",
              orderNum: 5,
              menuTab: 2
            }
          ]
        }
      ],
      currentMenu: [],
      typeOptions: [
        {
          key: "关键词回复",
          value: "click"
        },
        {
          key: "跳转网页",
          value: "view"
        },
        {
          key: "跳转小程序",
          value: "miniprogram"
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created() {
    this.currentMenu = this.oaMenu[0].list;
    this.queyOaMenu();
  },
  mounted() {},
  methods: {
    async queyOaMenu() {
      const { result } = await this.$store.dispatch("queyOaMenu");
      const oaMenu = JSON.parse(JSON.stringify(this.oaMenu));
      for (let i = 0; i < oaMenu.length; i++) {
        result.map(resultItem => {
          if (resultItem.menuTab === oaMenu[i].menuTab) {
            for (let j = 0; j < oaMenu[i].list.length; j++) {
              if (oaMenu[i].list[j].orderNum === resultItem.orderNum) {
                resultItem.levelName = oaMenu[i].list[j].levelName;
                if (!resultItem.value) {
                  resultItem.menuType = "";
                }
                oaMenu[i].list[j] = resultItem;
              }
            }
          }
        });
      }
      this.oaMenu = oaMenu;
      this.currentMenu = this.oaMenu[0].list;
    },
    async save() {
      let wxMenuList = [];
      this.oaMenu.map(v => {
        wxMenuList = wxMenuList.concat(v.list);
      });
      const { code } = await this.$store.dispatch("saveOaMenu", wxMenuList);
      if (code === 0) {
        this.$message({
          message: "操作成功",
          type: "success"
        });
      }
    },
    handleClick() {
      this.currentMenu = this.oaMenu[+this.activeTab].list;
    }
  }
};
</script>
<style lang="scss">
.table.oa-menu {
  .el-input {
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.table {
  border: 1px solid #e4e7ed;
  text-align: center;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
    > div {
      padding: 0 10px;
    }
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
</style>
